"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _vuex = require("vuex");
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  props: {
    showList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    delPermit: {
      type: String,
      default: ''
    },
    isInRow: Boolean,
    disabledFlag: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      hotInstance: null,
      TD: null,
      row: null,
      col: null,
      prop: null,
      value: null,
      cellProperties: null,
      tableListCS: [{
        codeValue: '0',
        displayValue: 'No Paid',
        displayValueCn: '未付款'
      }, {
        codeValue: '1',
        displayValue: 'Paied',
        displayValueCn: '已付款'
      }, {
        codeValue: '2',
        displayValue: 'Received',
        displayValueCn: '已到账'
      }],
      tableListIS: [{
        codeValue: '00',
        displayValue: 'Apply',
        displayValueCn: '申请'
      }, {
        codeValue: '01',
        displayValue: 'Accept',
        displayValueCn: '接受'
      }, {
        codeValue: '02',
        displayValue: 'Refuse',
        displayValueCn: '拒绝'
      }, {
        codeValue: '03',
        displayValue: 'Change',
        displayValueCn: '有变更'
      }]
    };
  },
  created: function created() {
    this.$permissions.loadPermissions('/standard');
  },
  computed: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language'])), {}, {
    isChecked: {
      get: function get() {
        // 将 0 转换为 false，将 1 转换为 true
        return this.value == "1";
      },
      set: function set(newValue) {
        // 将 true 转换为 1，将 false 转换为 0
        this.value = newValue ? "1" : "0";
      }
    }
  }),
  methods: {
    showName: function showName(arr, id) {
      var _this = this;
      if (arr instanceof Array) {
        var label = '';
        arr.some(function (item) {
          if (item.codeValue === id) {
            label = _this.language === 'zh' ? item.displayValueCn : item.displayValue;
            return true;
          }
        });
        return label;
      }
    },
    handleOpenDiaglog: function handleOpenDiaglog(value) {
      // this.$emit('handleOpenDiaglog', this.row)
      console.log(value);
      // window.open(value)
    }
  }
};